export default "__VITE_ASSET__CsrKy5YK__"